import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const RoleAssign = lazy(() => import('../role/role-assign/role-assign.component'));
const RoleCreatePredefined = lazy(() => import('../role/role-create-predefined/role-create-predefined.component'));
const RoleWizard = lazy(() => import('../role/role-wizard/role-wizard.component'));

export function CreateRoleRoutes() {
    return (
        <Route path='roles'>
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <RoleAssign />
                    </AsyncComponent>
                }
            />
            <Route
                path='wizard'
                element={
                    <AsyncComponent>
                        <RoleWizard />
                    </AsyncComponent>
                }
            />
            <Route
                path='predefined'
                element={
                    <AsyncComponent>
                        <RoleCreatePredefined />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
